<template>
  <!-- 增员详情弹框 -->
  <Modal v-model="visible" width="1300px" :title="title" :mask-closable="false" :footer-hide="true" class="my-modal top p-b">
    <Tabs v-model="tabName" :animated="false">
      <TabPane label="活动详情" name="1">
        <Form ref="form" :model="formData" :label-width="90" class="page-form">
          <FormItem prop="name" label="活动名称" class="full">
            <span>{{ formData.name }}</span>
          </FormItem>
          <FormItem prop="startTime" label="开始时间">
            <span>{{ formData.startTime || '-' }}</span>
          </FormItem>
          <FormItem prop="endTime" label="结束时间">
            <span>{{ formData.endTime || '-' }}</span>
          </FormItem>
          <FormItem prop="description" label="活动简介" class="full">
            <span>{{ formData.description }}</span>
          </FormItem>
          <FormItem prop="img" label="活动图片" class="full">
            <upLoadNew v-if="formData.img" :value="[{ path: formData.img }]" :disabled="true"></upLoadNew>
          </FormItem>
          <FormItem v-if="visible" prop="rule" label="活动规则" class="full">
            <span v-html="formData.rule"></span>
          </FormItem>
          <FormItem prop="remark" label="备注" class="full">
            <span>{{ formData.remark || '-' }}</span>
          </FormItem>
        </Form>
      </TabPane>
      <TabPane label="参与详情" name="2">
        <div class="content">
          <div class="search-box btn3" v-if="formData.type == 1 && formData.mode == 2 && [3, 6].includes(formData.conditionalIndicator * 1)">
            <div class="input-item">
              <span class="label">保单号</span>
              <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
            </div>
            <div class="input-item">
              <span class="label">产品名称</span>
              <Input v-model="searchParams.productName" placeholder="请输入" clearable />
            </div>
            <div class="input-item">
              <span class="label">险种名称</span>
              <Input v-model="searchParams.additionName" placeholder="请输入" clearable />
            </div>
            <div class="input-item">
              <span class="label">保单状态</span>
              <Select v-model="searchParams.status" filterable clearable transfer>
                <Option value="1">已承保</Option>
                <Option value="-1">已退保</Option>
                <Option value="0">已终止</Option>
              </Select>
            </div>
            <div class="input-item select-two">
              <Select v-model="searchParams.name" :transfer="true">
                <Option value="salesmanName">业务员姓名</Option>
                <Option value="staffNo">业务员工号</Option>
              </Select>
              <Input v-model="searchParams.nameValue" placeholder="请输入" clearable />
            </div>
            <div class="input-item select-two">
              <Select v-model="searchParams.nameJobNum" :transfer="true">
                <Option value="recommendName">推荐人姓名</Option>
                <Option value="recommendStaffNo">推荐人工号</Option>
              </Select>
              <Input v-model="searchParams.nameJobNumValue" placeholder="请输入" clearable />
            </div>
            <div class="input-item select-two" v-if="![3, 6].includes(formData.conditionalIndicator * 1) || formData.endorsementIsJoin != 1">
              <Select v-model="searchParams.timeName" :transfer="true">
                <Option value="startTime">生效日期</Option>
                <Option value="insureTime">承保日期</Option>
              </Select>
              <DatePicker
                type="daterange"
                split-panels
                separator="至"
                :transfer="true"
                placement="bottom"
                v-model="searchParams.timeValue"
                placeholder="选择日期"
              ></DatePicker>
            </div>
            <template v-if="formData.productType == 1">
              <div class="input-item">
                <span class="label">出单团队/机构</span>
                <selectTree type="2" @change="changeOrg" v-model="searchParams.orgId" :isAll="true"></selectTree>
              </div>
              <div class="input-item">
                <span class="label">回执状态</span>
                <lzDicSelect
                  v-model="searchParams.receiptStatusList"
                  dicType="RECEIPT_STATUS"
                  :transfer="true"
                  clearable
                  multiple
                  :disabled="searchParams.receiptStatusNull"
                >
                </lzDicSelect>
                <Checkbox v-model="searchParams.receiptStatusNull" class="null-radio" @on-change="$set(searchParams, 'receiptStatusList', [])">为空</Checkbox>
              </div>
              <div class="input-item">
                <span class="label">回访状态</span>
                <lzDicSelect
                  v-model="searchParams.verifyStatusList"
                  dicType="VERIFY_STATUS"
                  :transfer="true"
                  clearable
                  multiple
                  :disabled="searchParams.verifyStatusNull"
                >
                </lzDicSelect>
                <Checkbox v-model="searchParams.verifyStatusNull" class="null-radio" @on-change="$set(searchParams, 'verifyStatusList', [])">为空</Checkbox>
              </div>
              <div class="input-item">
                <span class="label">是否自保件</span>
                <RadioGroup v-model="searchParams.isSelfHold" @on-change="searchAjax()">
                  <Radio label="">全部</Radio>
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </div>
              <div class="input-item">
                <span class="label">是否互保件</span>
                <RadioGroup v-model="searchParams.isMutualHold" @on-change="searchAjax()">
                  <Radio label="">全部</Radio>
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </div>
              <div class="input-item">
                <span class="label">质检状态</span>
                <Select v-model="searchParams.confirmRightStatusIn" :transfer="true" clearable multiple>
                  <Option value="0">待单录</Option>
                  <Option value="1">待质检</Option>
                  <Option value="2">质检成功</Option>
                  <Option value="-1">质检失败</Option>
                </Select>
              </div>
              <div class="input-item">
                <span class="label">犹豫止期</span>
                <DatePicker
                  v-model="searchParams.hesitateDate"
                  type="daterange"
                  @on-change="changeHesitateDate"
                  split-panels
                  separator=" 至 "
                  :transfer="true"
                  placement="bottom"
                  format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></DatePicker>
              </div>
            </template>

            <div class="btn-item">
              <Button class="btn-item__item" type="primary" @click="searchAjax(), (listLoading = false)">查询</Button>
              <Button class="btn-item__item" type="primary" ghost @click="resetSearch(), (formData.receiptVerifyStatus = '')">重置</Button>
              <Button class="btn-item__item" type="warning" @click="daochu()" v-if="$units.pointAction('recruiting_1_2')">导出</Button>
              <!-- <detailAddPolicy class="btn-item__item" /> -->
            </div>
          </div>

          <!-- 增员无门槛搜索条件 -->
          <div class="search-box btn3" v-else-if="formData.mode == 1">
            <div class="input-item">
              <span class="label">产品名称</span>
              <Input v-model="searchParams.productName" placeholder="请输入" clearable />
            </div>
            <div class="input-item select-two">
              <Select v-model="searchParams.name" :transfer="true">
                <Option value="recommendName">推荐人</Option>
                <Option value="beRecommendedName">被推荐人</Option>
              </Select>
              <Input v-model="searchParams.nameValue" placeholder="请输入" clearable />
            </div>
            <div class="input-item">
              <span class="label">保单号</span>
              <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
            </div>
            <div class="input-item">
              <span class="label">保单状态</span>
              <Select v-model="searchParams.status" filterable clearable>
                <Option value="1">已承保</Option>
                <Option value="-1">已退保</Option>
                <Option value="0">已终止</Option>
              </Select>
            </div>
            <div class="input-item">
              <span class="label">出单团队/机构</span>
              <selectTree type="2" @change="changeOrg" v-model="searchParams.orgId" :isAll="true"></selectTree>
            </div>
            <div class="input-item select-two select-radio">
              <Select v-model="searchParams.workingState" :transfer="true" @on-change="searchAjax()">
                <Option value="recommendWorkingState">推荐人状态</Option>
                <Option value="beRecommendedWorkingState">被推荐人状态</Option>
              </Select>
              <RadioGroup v-model="searchParams.workingValue" @on-change="searchAjax()">
                <Radio label="">全部</Radio>
                <Radio label="-1">注册</Radio>
                <Radio label="1">在职</Radio>
                <Radio label="0">离职</Radio>
              </RadioGroup>
            </div>
            <div class="input-item">
              <span class="label">承保日期</span>
              <DatePicker
                type="daterange"
                split-panels
                separator="至"
                :transfer="true"
                placement="bottom"
                v-model="searchParams.insureTime"
                placeholder="选择日期"
              ></DatePicker>
            </div>
            <div class="input-item">
              <span class="label">生效日期</span>
              <DatePicker
                type="daterange"
                split-panels
                separator="至"
                :transfer="true"
                placement="bottom"
                v-model="searchParams.startTime2"
                placeholder="选择日期"
              ></DatePicker>
            </div>
            <div class="btn-item">
              <Button class="btn-item__item" type="primary" @click="searchAjax()">查询</Button>
              <Button class="btn-item__item" type="primary" ghost @click="resetSearch()">重置</Button>
              <Button class="btn-item__item" type="warning" @click="daochu2()" v-if="$units.pointAction('recruiting_1_2')">导出</Button>
              <!-- <detailAddPolicy class="btn-item__item" /> -->
            </div>
          </div>
          <!-- 增员梯度搜索条件 -->
          <div class="search-box btn3" v-else>
            <div class="input-item select-two" style="width: 50%">
              <Select v-model="searchParams.name" :transfer="true">
                <Option value="recommendName">推荐人</Option>
                <Option value="beRecommendedName">被推荐人</Option>
              </Select>
              <Input v-model="searchParams.nameValue" placeholder="请输入" clearable />
            </div>
            <div class="input-item select-two">
              <Select v-model="searchParams.nameJobNum" :transfer="true">
                <Option value="recommendName">推荐人姓名</Option>
                <Option value="recommendStaffNo">推荐人工号</Option>
              </Select>
              <Input v-model="searchParams.nameJobNumValue" placeholder="请输入" clearable />
            </div>
            <div class="input-item select-two select-width" style="width: 50%">
              <Select v-model="searchParams.mobileName" :transfer="true">
                <Option value="recommendMobile">推荐人手机号</Option>
                <Option value="beRecommendedMobile">被推荐人手机号</Option>
              </Select>
              <Input v-model="searchParams.mobileValue" placeholder="请输入" clearable />
            </div>
            <div class="input-item select-two select-radio" style="width: 50%">
              <Select v-model="searchParams.workingState" :transfer="true" @on-change="searchAjax()">
                <Option value="recommendWorkingState">推荐人状态</Option>
                <Option value="beRecommendedWorkingState">被推荐人状态</Option>
              </Select>
              <RadioGroup v-model="searchParams.workingValue" @on-change="searchAjax()">
                <Radio label="">全部</Radio>
                <Radio label="-1">注册</Radio>
                <Radio label="1">在职</Radio>
                <Radio label="0">离职</Radio>
              </RadioGroup>
            </div>
            <div class="input-item" style="width: 50%">
              <span class="label">注册日期</span>
              <DatePicker
                type="daterange"
                split-panels
                separator="至"
                :transfer="true"
                placement="bottom"
                v-model="searchParams.startTime"
                placeholder="选择日期"
              ></DatePicker>
            </div>
            <div class="input-item" style="width: 50%">
              <span class="label">入职日期</span>
              <DatePicker
                type="daterange"
                split-panels
                separator="至"
                :transfer="true"
                placement="bottom"
                v-model="searchParams.entryTime"
                placeholder="选择日期"
              ></DatePicker>
            </div>
            <div class="btn-item">
              <Button class="btn-item__item" type="primary" @click="searchAjax()">查询</Button>
              <Button class="btn-item__item" type="primary" ghost @click="resetSearch()">重置</Button>
              <Button class="btn-item__item" type="warning" @click="daochu()" v-if="$units.pointAction('recruiting_1_2')">导出</Button>
              <!-- <detailAddPolicy class="btn-item__item" /> -->
            </div>
          </div>

          <div class="statistics" style="margin-bottom: 15px" v-if="[3, 6].includes(rowData.conditionalIndicator * 1)">
            共计保单<strong>{{ statistics.policyNum }}</strong
            >单 ，规模保费为<strong>{{ statistics.feeSum }}</strong
            >元，标准保费为<strong>{{ statistics.foldFybSum }}</strong
            >元<span v-if="rowData.rewardType == 1"
              >，预计活动服务费为<strong>{{ statistics.rewardPriceSum }}</strong
              >元</span
            >
          </div>
          <div class="table-box">
            <loading :isShow="listLoading" />
            <Table
              :columns="columns3"
              :data="tableData"
              row-key="uniqueKey"
              :indent-size="0"
              v-if="formData.type == 1 && formData.mode == 2 && [3, 6].includes(formData.conditionalIndicator * 1)"
            >
              <template slot-scope="{ row }" slot="userName_staffNo">
                <div class="name-status">
                  <div class="user-box">
                    <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
                    <span class="user-name">{{ row.staffNo }}/{{ row.salesmanName }}</span>
                  </div>
                </div>
              </template>

              <template slot-scope="{ row }" slot="recommend_name">
                <div class="name-status">
                  <div class="user-box">
                    <i class="dian" :class="{ red: row.recommendWorkingState == 0, orange: row.recommendIsSus == 1 }"></i>
                    <span class="user-name">{{ row.recommendStaffNo }}/{{ row.recommendName }}</span>
                  </div>
                </div>
              </template>

              <template slot-scope="{ row }" slot="settlementStatus">
                <div class="settlement-status">
                  <span v-if="row.releaseStatus == '0'" class="tag-settled">未结算</span>
                  <span v-else class="tag-be">已结算</span>
                </div>
              </template>

              <template slot-scope="{ row }" slot="additionName">
                <div class="addition-name">
                  <span class="fu" v-if="row.additionName && !row.children">附</span>
                  <span>{{ row.additionName ? row.additionName : '-' }}</span>
                </div>
              </template>
            </Table>
            <Table :columns="formData.mode == 1 ? filterColumns() : columns" :data="tableData" v-else>
              <template slot-scope="{ row }" slot="recommendMobile" v-if="formData.mode != 1">
                <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
                  <span class="text" v-if="row.eyeShow1">{{ row.recommendMobile1 }}</span>
                  <span class="text" v-else>{{ row.recommendMobile }}</span>
                  <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow1" @click="openEye(row, 1)"></i>
                  <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow1" @click="openEye(row, 1)"></i>
                </div>
              </template>
              <template slot-scope="{ row }" slot="beRecommendedMobile" v-if="formData.mode != 1">
                <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
                  <span class="text" v-if="row.eyeShow2">{{ row.beRecommendedMobile1 }}</span>
                  <span class="text" v-else>{{ row.beRecommendedMobile }}</span>
                  <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow2" @click="openEye(row, 2)"></i>
                  <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow2" @click="openEye(row, 2)"></i>
                </div>
              </template>
            </Table>
            <div class="pageBox">
              <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
            </div>
          </div>
        </div>
      </TabPane>
    </Tabs>
  </Modal>
</template>

<script>
import lzDicSelect from "@/components/commons/lzDicSelect";
import editor from '@/components/commons/editor';
import upLoadNew from '@/components/commons/uploadNew';
import selectTree from '@/components/system/selectTree3';
import { pageTool } from '@/api/mixins';
import { filterTime } from '@/api/filter';
import { common } from '@/api/mixins';
// import detailAddPolicy from './detailAddPolicy.vue';
export default {
  mixins: [pageTool, common],
  components: { 
    editor, 
    lzDicSelect,
    upLoadNew,
    selectTree,
    // detailAddPolicy
  },
  props: [],
  data() {
    const vm = this;
    return {
      dic: JSON.parse(localStorage.dic),
      visible: false,
      tabName: '1',
      formData: {},
      statistics: {},
      rowData: {},
      nodeType: '',
      columns: [
        {
          title: '推荐人姓名',
          key: 'recommendName',
          align: 'center'
        },
        {
          title: '推荐人手机号',
          slot: 'recommendMobile',
          align: 'center'
        },
        {
          title: '推荐人状态',
          key: 'recommendWorkingState',
          align: 'center',
          render(h, params) {
            const type = params.row.recommendWorkingState;
            if (type == '0') {
              return <span>离职</span>;
            } else if (type == '1') {
              return <span>在职</span>;
            } else if (type == '-1') {
              return <span>注册</span>;
            }
          }
        },
        {
          title: '被推荐人姓名',
          key: 'beRecommendedName',
          align: 'center'
        },
        {
          title: '被推荐人手机号',
          slot: 'beRecommendedMobile',
          align: 'center'
        },
        {
          title: '被推荐人状态',
          key: 'beRecommendedWorkingState',
          align: 'center',
          render(h, params) {
            const type = params.row.beRecommendedWorkingState;
            if (type == '0') {
              return <span>离职</span>;
            } else if (type == '1') {
              return <span>在职</span>;
            } else if (type == '-1') {
              return <span>注册</span>;
            }
          }
        },
        {
          title: '注册日期',
          key: 'registerTime',
          align: 'center',
          width: '150',
          render(h, params) {
            return <span>{filterTime(params.row.registerTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '入职日期',
          key: 'entryTime',
          align: 'center',
          width: '150',
          render(h, params) {
            return <span>{filterTime(params.row.entryTime, 'YYYY-MM-DD')}</span>;
          }
        }
      ],
      columns2: [
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          ellipsis: true,
          tooltip: true,
          width: '200'
        },
        {
          title: '方案名称',
          key: 'grade',
          align: 'center',
          width: 100
        },
        {
          title: '被推荐人/状态',
          align: 'center',
          width: '200',
          render(h, params) {
            const type = params.row.beRecommendedWorkingState;
            let text = '';
            if (type == '0') {
              text = '离职';
            } else if (type == '1') {
              text = '在职';
            } else if (type == '-1') {
              text = '注册';
            }
            return <span>{params.row.beRecommendedName + '/' + text}</span>;
          }
        },
        {
          title: '推荐人/状态',
          align: 'center',
          width: '200',
          render(h, params) {
            const type = params.row.recommendWorkingState;
            let text = '';
            if (type == '0') {
              text = '离职';
            } else if (type == '1') {
              text = '在职';
            } else if (type == '-1') {
              text = '注册';
            }
            return <span>{params.row.recommendName + '/' + text}</span>;
          }
        },
        {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          width: '200'
        },
        {
          title: '批单号',
          width: '200',
          key: 'billNo',
          align: 'center',
          render(h, params) {
            return <span>{params.row.billNo ? params.row.billNo : '-'}</span>;
          }
        },
        {
          title: '保单状态',
          key: 'status',
          align: 'center',
          width: '100',
          render(h, params) {
            const status = params.row.status;
            if (status == 1) {
              return <span>已承保</span>;
            } else if (status == -1) {
              return <span>已退保</span>;
            } else if (status == 0) {
              return <span>已终止</span>;
            }
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          renderHeader(h, params) {
            if (vm.formData.calFactor == 1) {
              return <span>标准保费</span>;
            } else if (vm.formData.calFactor == 2) {
              return <span>规模保费</span>;
            } else if (vm.formData.calFactor == 3) {
              return <span>保费</span>;
            }
          },
          width: '100'
        },
        {
          title: '费用',
          key: 'commissionPrice',
          align: 'center',
          width: '100'
        },
        {
          title: '活动奖励率',
          key: 'rewardRate',
          align: 'center',
          width: '100',
          render(h, params) {
            return <span>{params.row.rewardRate || '-'}%</span>;
          }
        },
        {
          title: '活动奖励',
          align: 'center',
          width: '100',
          render(h, params) {
            return <span>{params.row.rewardPrice ? params.row.rewardPrice + '元' : ''}</span>;
          }
        },
        {
          title: '保障期',
          key: 'guaranteeLimit',
          align: 'center',
          width: '100',
          render(h, item) {
            const type = item.row.guaranteeType;
            let res = '';
            if (type == 1) {
              res = '保终身';
            } else if (type == 2) {
              res = `保${item.row.guaranteeLimit}岁`;
            } else if (type == 3) {
              res = `保${item.row.guaranteeLimit}年`;
            } else if (type == 4) {
              res = `保${item.row.guaranteeLimit}个月`;
            } else if (type == 5) {
              res = `保${item.row.guaranteeLimit}天`;
            }
            return <span>{res}</span>;
          }
        },
        {
          title: '交费期',
          key: 'payLimit',
          align: 'center',
          render(h, params) {
            return <span>{params.row.payLimit ? params.row.payLimit + '年' : ''}</span>;
          },
          width: '100'
        },
        {
          title: '承保日期',
          key: 'insureTime',
          align: 'center',
          width: '200'
        },
        {
          title: '生效日期',
          key: 'startTime',
          align: 'center',
          width: '200'
        },
        {
          title: '出单团队',
          key: 'groupName',
          align: 'center',
          width: '150'
        },
        {
          title: '出单机构',
          key: 'orgName',
          align: 'center',
          width: '150'
        }
      ],
      columns3: [],
      title: ''
    };
  },
  methods: {
    open(data) {
      this.title = `${data.name}-详情`;
      this.searchParams = {};
      this.rowData = data;
      this.getDetail(data.id);
      this.visible = true;
      this.columns3 = [
        {
          title: '保单号',
          key: 'policyNo',
          align: 'left',
          width: '220',
          tree: true,
          fixed: 'left',
          render(h, params) {
            return <span>{params.row.policyNo ? params.row.policyNo : '-'}</span>;
          }
        },
        {
          title: '批单号',
          align: 'left',
          width: '200',
          fixed: 'left',
          render(h, params) {
            return <span>{params.row.billNo ? params.row.billNo : '-'}</span>;
          }
        },
        {
          title: '出单业务员',
          key: 'salesmanName',
          align: 'center',
          width: '200',
          fixed: 'left',
          slot: 'userName_staffNo'
        },
        {
          title: '推荐人',
          align: 'center',
          width: '200',
          slot: 'recommend_name'
        },
        {
          title: '规模保费',
          key: 'fee',
          align: 'center',
          width: '100'
        },
        {
          title: '标准保费',
          key: 'foldFyb',
          align: 'center',
          width: '100'
        },
        {
          title: '出单服务费',
          key: 'commissionPrice',
          align: 'center',
          width: '100'
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          ellipsis: true,
          tooltip: true,
          width: '200'
        },
        {
          title: '险种名称',
          key: 'additionName',
          align: 'center',
          width: '200',
          slot: 'additionName'
        },
        {
          title: '交费期',
          key: 'payLimit',
          align: 'center',
          render(h, params) {
            return <span>{params.row.payLimit ? params.row.payLimit + '年' : ''}</span>;
          },
          width: '100'
        },
        {
          title: '保障期',
          key: 'guaranteeLimit',
          align: 'center',
          width: '100',
          render(h, item) {
            const type = item.row.guaranteeType;
            let res = '';
            if (type == 1) {
              res = '保终身';
            } else if (type == 2) {
              res = `保${item.row.guaranteeLimit}岁`;
            } else if (type == 3) {
              res = `保${item.row.guaranteeLimit}年`;
            } else if (type == 4) {
              res = `保${item.row.guaranteeLimit}个月`;
            } else if (type == 5) {
              res = `保${item.row.guaranteeLimit}天`;
            }
            return <span>{res}</span>;
          }
        },
        {
          title: '出单机构/团队',
          key: 'orgName',
          align: 'center',
          width: '150',
          render(h, params) {
            return <span>{params.row.orgName + '/' + params.row.groupName}</span>;
          }
        },
        {
          title: '生效日期',
          key: 'startTime',
          align: 'center',
          width: '120',
          render(h, params) {
            return <span>{filterTime(params.row.startTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '承保日期',
          key: 'insureTime',
          align: 'center',
          width: '120',
          render(h, params) {
            return <span>{filterTime(params.row.insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保单状态',
          key: 'status',
          align: 'center',
          width: '100',
          render(h, params) {
            const status = params.row.status;
            if (status == 1) {
              return <span>已承保</span>;
            } else if (status == -1) {
              return <span>已退保</span>;
            } else if (status == 0) {
              return <span>已终止</span>;
            }
          }
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 120,
          slot: 'settlementStatus'
        },
        {
          title: '回执状态',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            const text = this.dic.RECEIPT_STATUS[params.row.receiptStatus];
            return <span>{ text || '-' }</span>;
          }
        },
        {
          title: '回访状态',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            const text = this.dic.VERIFY_STATUS[params.row.verifyStatus];
            return <span>{ text || '-' }</span>;
          }
        },
        {
          title: '犹豫期截止日',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{hesitateDate ? filterTime(hesitateDate, 'YYYY-MM-DD') : '-'}</span>;
          }
        }
      ];
      if (data.productType != 2) {
        this.columns3 = this.columns3.filter(item => item.title != '批单号');
      }
      // 增员-梯度
      if (data.type == 1 && data.mode == 2) {
        this.columns3 = this.columns3.filter(item => item.title != '结算状态');
      }
    },
    getDetail(id) {
      this.$http({
        url: '/buz/merchantActivity/detail',
        type: 'get',
        data: {
          id
        }
      }).then(res => {
        this.formData = res.data;
        if (this.formData.type == 1 && this.formData.mode == 2 && [3, 6].includes(this.formData.conditionalIndicator * 1)) {
          this.searchParams.name = 'salesmanName';
          this.searchParams.timeName = 'startTime';
          this.searchParams.nameJobNum = 'recommendName';
          this.initListAjax('/buz/merchantActivity/queryPolicyListNew');
        } else if (this.formData.mode == 2) {
          this.searchParams.name = 'recommendName';
          this.searchParams.workingState = 'recommendWorkingState';
          this.searchParams.mobileName = 'recommendMobile';
          this.searchParams.nameJobNum = 'recommendName';
          this.initListAjax('/buz/merchantActivity/queryRecommendList');
        } else {
          this.searchParams.name = 'recommendName';
          this.searchParams.workingState = 'recommendWorkingState';
          this.initListAjax('/buz/merchantActivity/queryBeRecommendPolicyList');
        }
      });
    },
    changeHesitateDate(time) {
      this.searchParams.hesitateStartTime = time[0];
      this.searchParams.hesitateEndTime = time[1];
    },
    listCallback(res) {
      this.$nextTick(() => {
        if (this.formData.type == 1 && this.formData.mode == 2 && [3, 6].includes(this.formData.conditionalIndicator * 1)) {
          this.tableData = res.data?.data?.records;
          this.total = res.data?.data?.total;
          this.statistics = res.data?.statistics;
        }
      });
    },
    setListParams(params) {
      params.activityId = this.formData.id;
      params.receiptVerifyStatus = this.formData.receiptVerifyStatus;
      if (this.nodeType == 2) {
        params.groupId = params.orgId;
        delete params.orgId;
      }
      if (params.nameValue) {
        params[params.name] = params.nameValue;
      }
      if (params.nameJobNumValue) {
        params[params.nameJobNum] = params.nameJobNumValue;
      }
      if (params.workingValue) {
        params[params.workingState] = params.workingValue;
      }
      if (params.mobileValue) {
        params[params.mobileName] = params.mobileValue;
      }
      if (params.timeValue) {
        params[params.timeName] = params.timeValue;
      }
      if (params.insureTime && params.insureTime[0]) {
        params.insureTimeStart = filterTime(params.insureTime[0], 'YYYY-MM-DD');
        params.insureTimeEnd = filterTime(params.insureTime[1], 'YYYY-MM-DD');
        delete params.insureTime;
      }
      delete params.name;
      delete params.nameValue;
      delete params.nameJobNum;
      delete params.nameJobNumValue;
      delete params.workingState;
      delete params.workingValue;
      delete params.mobileName;
      delete params.mobileValue;
      delete params.hesitateDate;
      delete params.timeValue;
      delete params.timeName;
      // 回执状态
      if(params.receiptStatusNull) {
        params.receiptStatusList = [];
      }
      params.receiptStatusNull = params.receiptStatusNull ? 1 : 0;
      // 回访状态
      if(params.verifyStatusNull) {
        params.verifyStatusList = [];
      }
      params.verifyStatusNull = params.verifyStatusNull ? 1 : 0;
      if (this.formData.mode == 2) {
        if (params.startTime && params.startTime[0]) {
          params.registerTimeStart = filterTime(params.startTime[0], 'YYYY-MM-DD');
          params.registerTimeEnd = filterTime(params.startTime[1], 'YYYY-MM-DD');
          delete params.startTime;
        }
        if (params.entryTime && params.entryTime[0]) {
          params.entryTimeStart = filterTime(params.entryTime[0], 'YYYY-MM-DD');
          params.entryTimeEnd = filterTime(params.entryTime[1], 'YYYY-MM-DD');
          delete params.entryTime;
        }
      } else {
        delete params.startTime;
        delete params.entryTime;
        if (params.insureTime && params.insureTime[0]) {
          params.insureTimeStart = filterTime(params.insureTime[0], 'YYYY-MM-DD');
          params.insureTimeEnd = filterTime(params.insureTime[1], 'YYYY-MM-DD');
        }
        delete params.insureTime;
        if (params.startTime2 && params.startTime2[0]) {
          params.startTimeStart = filterTime(params.startTime2[0], 'YYYY-MM-DD');
          params.startTimeEnd = filterTime(params.startTime2[1], 'YYYY-MM-DD');
        }
        delete params.startTime2;
      }
    },
    filterColumns() {
      const data = this.rowData;
      let columns2 = [].concat(this.columns2);
      if (data.type == 1) {
        columns2[1] = {
          title: '险种名称',
          key: 'additionName',
          align: 'center',
          width: 100
        };
      } else {
        columns2[1] = {
          title: '方案名称',
          key: 'grade',
          align: 'center',
          width: 100
        };
      }
      // 不存在团财保单类型过滤批单号
      if (data.joinPolicyType && !(data.joinPolicyType.includes('2') || data.joinPolicyType.includes('3') || data.joinPolicyType.includes('4'))) {
        columns2 = columns2.filter(item => item.title != '批单号');
      }
      if (data.calFactor != 3) {
        columns2 = columns2.filter(item => item.title != '费用');
      }
      return columns2;
    },
    daochu() {
      if (!this.tableData.length) {
        this.$notice.msg('暂无可导出数据');
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile(
        this.formData.type == 1 && this.formData.mode == 2 && this.formData.conditionalIndicator == 1
          ? '/buz/merchantActivity/exportRecommendList'
          : '/buz/merchantActivity/exportPolicyList',
        params,
        'POST'
      );
    },
    daochu2() {
      if (!this.tableData.length) {
        this.$notice.msg('暂无可导出数据');
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/merchantActivity/exportBeRecommendPolicyList', params, 'POST');
    },
    changeOrg(data) {
      this.nodeType = data.nodeType;
    },
    // 解密
    openEye(row, key) {
      if (!row['eyeShow' + key]) {
        this.descrypt(
          {
            query: key == 1 ? row.recommendId : row.beRecommendedId,
            operationFunction: 13,
            operationType: 2
          },
          row,
          key == 1 ? 'recommendMobile1' : 'beRecommendedMobile1'
        ).then(() => {
          this.$set(row, 'eyeShow' + key, true);
        });
      } else {
        this.$set(row, 'eyeShow' + key, false);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.null-radio {
  padding-left: 10px;
  line-height: 30px;
  white-space: nowrap;
}
.detail {
  /deep/.ivu-modal-body {
    padding-bottom: 30px;
  }
  /deep/.ivu-tabs-content {
    height: 600px;
    overflow-y: scroll;
  }
  .select-radio {
    .ivu-select {
      width: 120px;
      flex-shrink: 0;
      margin-right: 5px;
      /deep/.ivu-select-selection {
        border-radius: 2px;
        border-right: 1px solid #dcdee2;
      }
    }
  }
  .select-width {
    .ivu-select {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
.settlement-status {
  display: flex;
  justify-content: center;
  .tag-settled {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 2px;
    font-size: 13px;
    color: #e3461f;
    border: 1px solid #ffc1b2;
    background: #fff5f2;
  }
  .tag-be {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
    color: #35bf3f;
    border: 1px solid #abeaae;
    background: #f6fcf4;
  }
}
.name-status {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .user-box {
    display: flex;
    align-items: center;
    font-size: 12px;
    padding-left: 10px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
    }
  }
}
.btn-item {
  bottom: auto;
  width: 260px;
  .btn-item__item {
    margin-left: 0 !important;
    margin-right: 10px;
    margin-bottom: 10px;

    &:nth-of-type(3n) {
      margin-right: 0;
    }
  }
}
</style>
